import React, { useEffect, useState } from "react";
import { Slide } from "react-slideshow-image";
// import "react-slideshow-image/dist/styles.css";
// import "./Testimonials.scss";

const defaultTestimonials = [
  {
    name: "James Okoye",
    role: "Head Nurse, St. Marys Hospital",
    quote: "The CNA training was hands-on and job-ready.",
    rating: 5,
  },
  {
    name: "Dr. Amina Yusuf",
    role: "Clinic Manager, ABC Clinic",
    quote:
      "Chaol Carington supplied our monitors and provided quick onsite servicing — reliable and professional.",
    rating: 5,
  },
  {
    name: "Grace Eze",
    role: "Procurement, Hope Medical Center",
    quote: "Great prices on consumables and fast delivery.",
    rating: 5,
  },
  {
    name: "Michael Ade",
    role: "Biomedical Engineer",
    quote: "The technician course improved my repair workflow.",
    rating: 5,
  },
  {
    name: "Fatima Bello",
    role: "Clinic Owner",
    quote: "Excellent support and maintenance plans.",
    rating: 5,
  },
];

// ⭐ simple star component
const Stars = ({ count = 5 }) => (
  <div className="testimonial-stars">
    {Array.from({ length: count }).map((_, i) => (
      <span key={i}>★</span>
    ))}
  </div>
);

const Testimonials = ({ items = defaultTestimonials }) => {
  const initialSlides =
    typeof window !== "undefined" && window.innerWidth < 768 ? 1 : 3;
  const [slidesToShow, setSlidesToShow] = useState(initialSlides);
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const onResize = () => setSlidesToShow(window.innerWidth < 768 ? 1 : 3);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const settings = {
    autoplay: true,
    arrows: true,
    infinite: true,
    slidesToShow,
    onChange: (_, newIndex) => setCurrent(newIndex),
  };

  const centerIndex = (current + Math.floor(slidesToShow / 2)) % items.length;

  return (
    <section className="testimonials">
      <div className="testimonials__header">
        <h2 className="featured__header__main">What Our Clients Say</h2>
        <p>
          Real feedback from healthcare professionals and institutions we've
          worked with.
        </p>
      </div>
      <div className="testimonials__inner">
        <Slide {...settings}>
          {items.map((t, i) => {
            const isCenter = slidesToShow === 1 ? true : i === centerIndex;
            return (
              <div
                key={i}
                className={`testimonial-slide ${isCenter ? "testimonial-slide--center" : ""}`}
              >
                <article className="testimonial-card">
                  <Stars count={t.rating} /> {/* ⭐ stars added here */}
                  <p className="testimonial-card__quote">“{t.quote}”</p>
                  <div className="testimonial-card__meta">
                    <strong>{t.name}</strong>
                    <span>{t.role}</span>
                  </div>
                </article>
              </div>
            );
          })}
        </Slide>
      </div>
    </section>
  );
};

export default Testimonials;
